<latam-error-message></latam-error-message>
<latam-it-loader></latam-it-loader>
<router-outlet (activate)="blockToPrevious()"></router-outlet>
